import {
    ChangeDetectionStrategy,
    Component,
    computed,
    inject,
    OnDestroy,
    OnInit,
    ViewEncapsulation
} from '@angular/core';
import { FiOnboardingReportWidgetBaseDirective } from '../fi-onboarding-widget-base.directive';
import { IPeriodDateRange } from '@fi-app/shared/fi-time-range-menu/fi-time-range-menu';
import { FiOnboardingReportDateService } from '@fi-app/fi-onboarding/fi-onboarding-report/services/fi-onboarding-report-date.service';
import { FiOnboardingReportDateType } from '@fi-app/fi-onboarding/fi-onboarding-report/fi-onboarding-report-enums';
import { IOnboardingPeriodDateRange } from '@fi-app/fi-onboarding/fi-onboarding-report/fi-onboarding-report';
import { Subject } from 'rxjs';

@Component({
    selector: 'fi-total-participants-onboarded-widget',
    templateUrl: './total-participants-onboarded-widget.component.html',
    styleUrls: ['./total-participants-onboarded-widget.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-total-participants-onboarded-widget' },
    standalone: false,
})
export class FiTotalParticipantsOnboardedWidgetComponent
    extends FiOnboardingReportWidgetBaseDirective
    implements OnInit, OnDestroy
{
    private fiOnboardingReportDateService = inject(FiOnboardingReportDateService);

    protected widgetData = computed(() => {
        return {
            description: this.widgetDescription(),
            icon: this.widgetIcon(),
            summaryCount: this.reportData().ParticipantsSummary.CompletedCount,
        };
    });

    protected timeIntervalOptions = this.fiOnboardingReportDateService.TimeIntervalOptions;
    protected periodDateRange: IPeriodDateRange<FiOnboardingReportDateType>;

    public ngOnInit(): void {
        this.fiOnboardingReportDateService.resetDateRange(this.widget().Id);
        this.periodDateRange = this.fiOnboardingReportDateService.getDateRange(this.widget().Id);
        this.subscribeOnDateRangeChanged();
    }

    private subscribeOnDateRangeChanged(): void {
        this.fiOnboardingReportDateService.subscribeOnDateRangeChanged(this.widget().Id, this.ngOnDestroy$, () => {
            this.fiOnboardingReportDateService.updateSummary(this.widget());
        });
    }

    protected setOnboardingDateRange(newRange: IOnboardingPeriodDateRange): void {
        this.fiOnboardingReportDateService.setNewDateRange(this.widget().Id, newRange);
    }

    private ngOnDestroy$ = new Subject<void>();
    public ngOnDestroy(): void {
        this.ngOnDestroy$.next();
        this.ngOnDestroy$.complete();
    }

    protected readonly FiOnboardingReportDateType = FiOnboardingReportDateType;
}
